// extracted by mini-css-extract-plugin
export default {"pageWrap":"nb-z","fullWidth":"ob-z","heading":"pb-z","fullBleed":"qb-z","hidden":"rb-z"};